export class DoctorQueryOptionsModel {
  isLazyLoad: boolean = true;
  LOCID: number = -1;
  isIncludeReferring: boolean = false;
  isIncludeTdo: boolean = true;
  isActiveOnly = false;
  PatientId: string = "";
}

export class  ReferringDoctorQueryOptionsModel {
  isLazyLoad: boolean = false;
  ReferralEntityID: string;
}

